import {SELECIONAR_ACRESCIMO_PASSAGEM_USUARIO } from '../../actions/types'

const initialState = null

export default function reducerAcrescimoPassagemUsuarioSelecionado (state = initialState, action ) {
  switch (action.type) {
    case SELECIONAR_ACRESCIMO_PASSAGEM_USUARIO: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
